import { render, staticRenderFns } from "./procurementPlanSummary.vue?vue&type=template&id=92498ed6&scoped=true"
import script from "./procurementPlanSummary.vue?vue&type=script&lang=js"
export * from "./procurementPlanSummary.vue?vue&type=script&lang=js"
import style0 from "./procurementPlanSummary.vue?vue&type=style&index=0&id=92498ed6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92498ed6",
  null
  
)

export default component.exports